// import a from '@webcomponents/webcomponentsjs/webcomponents-loader.js'
// import b from '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js'
import router from 'components/router';
import Loader from 'components/loader';
import Home from 'components/home';
import About from 'components/about';
import Work from 'components/work';
import Works from 'components/works';
import Logo from 'components/logo';
import Nav from 'components/nav';
import Noise from 'components/canvas-noise';
import NavLink from 'components/nav-link';
import FetchLoader from 'lib/fetch-loader';
import store from 'lib/store';
import * as style from './style';
let loader;
let $main = document.body.querySelector('main');
document.body.classList.add('u-loading'); // let preloader = new FetchLoader({
//     baseURL: ENV.assetsURL,
//     manifest: [
//         'noise.png'
//     ]
// })
// preloader.load().then(e => {
// let texture = preloader.assets.get('noise.png')

let noise = new Noise({
  parent: $main,
  opacity: 0.06 // texture

});
load(); // })

function load() {
  loader = new Loader({
    baseURL: ENV.assetsURL,
    manifest: ['https://rudyvermorel.com/back/api/collections/get/Work?token=d98f20b0cd8a752dcc8bb7479221fd', 'https://rudyvermorel.com/back/api/singletons/get/copy?token=d98f20b0cd8a752dcc8bb7479221fd', 'https://rudyvermorel.com/back/api/singletons/get/About?token=d98f20b0cd8a752dcc8bb7479221fd']
  });
  $main.appendChild(loader);
  loader.addEventListener('complete', function onComplete(event) {
    loader.removeEventListener('complete', onComplete);
    start(event);
    noise.start();
  });
}

function start(_ref) {
  let {
    detail: assets
  } = _ref;
  $main.classList.remove('u-loading');
  store.set('assets', assets);
  store.set('content', assets.get('content.json'));
  $main.appendChild(new Logo());
  $main.appendChild(new Nav());
  router.start({
    basePath: ENV.baseURL,
    routes: {
      home: Home,
      campaigns: Works,
      more: Works,
      about: About,
      work: Work
    },
    default: 'home',
    root: $main
  });
  router.once('route', route => {
    loader.leave(route);
  });
  document.body.classList.remove('u-loading');
}